<div class="animated fadeIn rounded">
    <div class="card">
        <div class="card-header">
            <i class="fa fa-gift"></i> Devolver Giftcard {{giftCard.giftCardNumber}}
            <div class="card-header-actions btn-group" dropdown placement="bottom left">
            </div>
        </div>

        <div class="card-body">
            <app-return-save-step [order]="order" (doReturn)="return($event)"
                [disableRouting]="true"></app-return-save-step>
        </div>
    </div>
</div>